import dayjs from 'dayjs';
import type { Evento } from '../interfaces/evento';

export const isEventoVisible = (evento: Pick<Evento, 'visible_desde'>) => {
  if (evento.visible_desde) {
    return dayjs().isAfter(dayjs(evento.visible_desde));
  }
  return false;
};
